import useNetworks from './useNetworks'

export default useNetworks
